import { toast } from "react-toastify";
import { AUDIT_CALL } from "../config/apiEndPoint";
import { GET, POST, PUT, MULTIPART_POST } from "config/api.config";

const safeAuditId = (id) => encodeURIComponent(String(id ?? "").trim());

export const getCallAuditMetadata = async () => {
  try {
    const response = await GET(AUDIT_CALL.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCallAuditFilterData = async (data = {}) => {
  try {
    const response = await POST(AUDIT_CALL.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `Audit/create-batch/date-range` */
export const fetchCreateAuditBatchDateRange = async (data = {}) => {
  try {
    const response = await GET(AUDIT_CALL.CREATE_BATCH_DATE_RANGE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Audit/create-batch` */
export const submitCreateAuditBatch = async (data = {}) => {
  try {
    const response = await POST(AUDIT_CALL.CREATE_BATCH, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET Audit/{auditId}/edit */
export const getCallAuditForEdit = async (auditId) => {
  const id = String(auditId ?? "").trim();
  if (!id) {
    toast.error("Audit ID is required");
    return undefined;
  }
  try {
    const response = await GET(AUDIT_CALL.FOR_EDIT(safeAuditId(id)));
    return response;
  } catch {
    return undefined;
  }
};

/** PUT Audit/{auditId} — main audit body (JSON). */
export const updateCallAudit = async (auditId, data = {}) => {
  const id = String(auditId ?? "").trim();
  if (!id) {
    toast.error("Audit ID is required");
    return undefined;
  }
  try {
    const response = await PUT(AUDIT_CALL.UPDATE(safeAuditId(id)), data);
    return response;
  } catch {
    return undefined;
  }
};

/**
 * Build multipart/form-data for Audit/{auditId}/files.
 * Parallel arrays (same order per row): file[], notes[], existingFileId[].
 * - file: binary File for new upload, existing id string when unchanged, or ""
 * - notes: string
 * - existingFileId: string
 */
export const buildCallAuditFilesFormData = (mediaRows = []) => {
  const fd = new FormData();

  mediaRows.forEach((row = {}) => {
    const existingFileId = String(row?.existingFileId ?? "").trim();
    const notes = row?.notes != null ? String(row.notes) : "";

    if (row?.file instanceof File) {
      fd.append("file", row.file, row.file.name || "upload");
    } else if (existingFileId) {
      fd.append("file", existingFileId);
    } else {
      fd.append("file", "");
    }

    fd.append("notes", notes);
    fd.append("existingFileId", existingFileId);
  });

  return fd;
};

/** POST Audit/{auditId}/files (multipart). */
export const submitCallAuditFiles = async (auditId, formData) => {
  const id = String(auditId ?? "").trim();
  if (!id) {
    toast.error("Audit ID is required");
    return undefined;
  }
  if (!(formData instanceof FormData)) {
    toast.error("Invalid upload payload");
    return undefined;
  }
  try {
    const response = await MULTIPART_POST(AUDIT_CALL.FILES(safeAuditId(id)), formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
